import Sucsess from './Sucsess.vue';

export default Sucsess;



// WEBPACK FOOTER //
// ./src/pages/profile/views/certificate/components/sucsess/index.ts